import { Ref } from 'vue';

export const equalizeRowHeights = (containerRef: Ref<HTMLElement | null> | HTMLElement | null, selector: string) => {
  const el =
    containerRef instanceof HTMLElement ? containerRef : ((containerRef?.value as any)?.$el ?? containerRef?.value);
  if (!el || !(el instanceof HTMLElement)) return;
  const rows = el.querySelectorAll<HTMLElement>(selector);
  let max = 0;
  rows.forEach((row) => {
    row.style.minHeight = '';
    max = Math.max(max, row.offsetHeight);
  });
  rows.forEach((row) => {
    row.style.minHeight = `${max}px`;
  });
};
